import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { FileText } from "lucide-react";
import { VoiceInputButton } from "@/components/VoiceInputButton";

export function ServiceReportWorkDescription({
  title,
  setTitle,
  serviceDate,
  setServiceDate,
  technicianName,
  setTechnicianName,
  technicians = [],
  description,
  setDescription,
}) {
  return (
    <Card>
      <CardHeader className="p-4 md:p-6">
        <CardTitle className="flex items-center gap-2 text-lg md:text-xl">
          <FileText className="w-5 h-5" />
          Arbeitsbeschreibung
        </CardTitle>
      </CardHeader>
      <CardContent className="p-4 md:p-6 pt-0 md:pt-0 space-y-4 md:space-y-6">
        <div className="grid gap-4 md:gap-6 sm:grid-cols-2">
          <div className="space-y-2">
            <Label htmlFor="title">Grund *</Label>
            <Input
              id="title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="z.B. Wartung und Updates"
              required
              className="h-11 md:h-9 text-base md:text-sm"
              data-testid="title-input"
            />
          </div>
          <div className="grid grid-cols-2 gap-3 md:gap-4">
            <div className="space-y-2">
              <Label htmlFor="service_date">Datum *</Label>
              <Input
                id="service_date"
                type="date"
                value={serviceDate}
                onChange={(e) => setServiceDate(e.target.value)}
                required
                className="h-11 md:h-9 text-base md:text-sm"
                data-testid="service-date-input"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="technician">Techniker</Label>
              <select
                id="technician"
                value={technicianName}
                onChange={(e) => setTechnicianName(e.target.value)}
                className="flex h-11 md:h-9 w-full rounded-md border border-input bg-transparent px-3 py-2 text-base md:text-sm shadow-sm focus:outline-none focus:ring-1 focus:ring-ring"
                data-testid="technician-select"
              >
                <option value="">Techniker</option>
                {technicians.map((tech) => (
                  <option key={tech} value={tech}>{tech}</option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <Label htmlFor="description">Beschreibung *</Label>
            <VoiceInputButton
              label="Diktieren"
              onTranscript={(text) =>
                setDescription((prev) => (prev ? prev + " " : "") + text)
              }
            />
          </div>
          <Textarea
            id="description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Detaillierte Beschreibung der durchgeführten Arbeiten..."
            rows={4}
            required
            className="text-base md:text-sm min-h-[120px]"
            data-testid="description-input"
          />
        </div>
      </CardContent>
    </Card>
  );
}
